import { isLoadingReducer } from 'store/reducerUtils';
import { setSubmittingOrgStatus } from 'modules/settings/submodules/clients/submittingOrg/components/UpdateStatusSelect/store/actions';

export const isSubmittingOrgStatusUpdating = isLoadingReducer(setSubmittingOrgStatus);
